import type { PackageStatus } from '../enums/PackageStatus'

export class PackageStatusLogEntity {
  id?: string
  packageId?: string
  status?: PackageStatus
  createdAt?: string
}
